/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Col } from "reactstrap";
import Chart from "react-apexcharts";
import _ from "lodash";
import ReactApexChart from "react-apexcharts";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
const DonutChartProfile = ({ isLoading, name, sections }) => {
  console.log("section---", sections);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  // Usage example
  // sections = [
  //   { value: 25, color: "#ff6347", label: "Section 1" }, // red section
  //   { value: 25, color: "#ffa500", label: "Section 2" }, // orange section
  //   { value: 25, color: "#32cd32", label: "Section 3" }, // green section
  //   { value: 25, color: "#6a5acd", label: "Section 4" }, // blue section
  // ];
  // console.log("series", series);
  // const chartData = {
  //   series: series, // Data for the donut chart
  //   options: {
  //     chart: {
  //       type: "donut",
  //     },
  //     colors: colors,
  //     labels: labels,
  //     stroke: {
  //       width: 10,
  //       colors: ["#ffffff"],
  //     },
  //     legend: { show: false },
  //     responsive: [
  //       {
  //         breakpoint: 480,
  //         options: {
  //           chart: {
  //             width: 200,
  //           },
  //           legend: {
  //             position: "bottom",
  //           },
  //         },
  //       },
  //     ],
  //   },
  // };

  const numbers = sections.reduce((acc, section) => {
    acc[section.value] = section.number;
    return acc;
  }, {});

  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const sectionGap = 4; // gap between sections in degrees

  const calculateStrokeDashoffset = (percentage) => {
    return circumference - (percentage / 100) * circumference;
  };

  const values = sections.map((section) => section.value);
  const noDataValue = ["100"];
  const colors = sections.map((section) => section.color);

  const options = {
    chart: {
      type: "donut",
    },
    labels: _.isEmpty(sections)
      ? ["No data found"]
      : sections.map((section) => section.label),
    colors: _.isEmpty(sections) ? ["#707070"] : colors,
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "16px",
              fontWeight: 600,
              offsetY: -10,
            },
            value: {
              show: true,
              fontSize: "14px",
              offsetY: 10,
              formatter: function (val, { seriesIndex }) {
                const section = sections[seriesIndex];
                console.log("number--", numbers, numbers[val]);
                return tab === "4" || tab === "5"
                  ? numbers[val]
                  : Math.round(val) + "%";
              },
            },
            total: {
              show: true,
              label: name,
              formatter: function (w) {
                return "Progression";
              },
            },
          },
        },
        expandOnClick: false,
        offsetY: 0,
        offsetX: 0,
        dataLabels: {
          offset: 0,
          minAngleToShowLabel: 10,
        },
        customScale: 1,
      },
    },
    stroke: {
      show: true,
      width: 10,
      colors: ["#fff"], // White color for the gaps
      lineCap: "round",
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return Math.round(val) + "%"; // Append the percentage sign to the value in tooltip
        },
        title: {
          formatter: function (seriesName, { seriesIndex }) {
            const section = sections[seriesIndex];
            return seriesName;
            // section?.number
            //   ? `${seriesName}: ${section.number}`
            //   : seriesName// Display the series name with the number attribute
          },
        },
      },
    },
  };

  return !_.isEmpty(sections) ? (
    <>
      <ReactApexChart
        options={options}
        series={values}
        width={250}
        type="donut"
        height={250}
      />
    </>
  ) : (
    <>
      <ReactApexChart
        options={options}
        series={noDataValue}
        width={250}
        type="donut"
        height={250}
      />
    </>
  );
};

export default DonutChartProfile;
